<template>
  <base-container>
    <Resource></Resource>
  </base-container>
</template>

<script>
import Resource from "./Summary.vue";
export default {
  components: {
    Resource,
  },
  data() {
    return {};
  },
};
</script>

<style></style>
